<template>
  <div class="container">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="row">
        <div class="col-11 text-center mb-4">
          <h4>{{ name }} contrato</h4>
          <h6>{{ contrato.folio }}</h6>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-6">
              <div class="row">
                <div class="form-group autocomplete col-12">
                  <label for="nomcli">Cliente</label>
                  <input type="text" class="form-control" id="nomcli" name="nomcli" placeholder="Cliente" />
                </div>
                <div class="form-group col-6">
                  <label for="fecha_ini">Fecha Inicio</label>
                  <input type="date" class="form-control" v-model="contrato.fecha_ini" id="fecha_ini" />
                </div>
                <div class="form-group col-6">
                  <label for="fecha_fin">Fecha Fin</label>
                  <input type="date" class="form-control" v-model="contrato.fecha_fin" id="fecha_fin" />
                </div>
                <div class="form-group col-4">
                  <label for="cant_user_web">Usuarios Web</label>
                  <input type="number" class="form-control" id="cant_user_web" v-model="contrato.cant_user_web" min="1" max="100" step="1" />
                </div>
                <div class="form-group col-4">
                  <label for="cant_user_movil">Disp Móvil</label>
                  <input type="number" class="form-control" id="cant_user_movil" v-model="contrato.cant_user_movil" min="1" max="100" step="1" />
                </div>
                <div class="form-group col-4">
                  <label for="cant_sucursales">Sucursales</label>
                  <input type="number" class="form-control" id="cant_sucursales" v-model="contrato.cant_sucursales" min="1" max="100" step="1" />
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-12 text-center">
                  <h4>Módulos</h4>
                </div>
                <div class="col-12 px-5 mt-3">
                  <div class="row">
                    <div class="form-check col-4 mt-2" v-for="modulo of modulos">
                      <input class="form-check-input" type="checkbox" v-model="modulo.check" v-bind:id="modulo.idmodulo" />
                      <label class="form-check-label">
                        {{ modulo.nommodulo }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3 justify-content-center">
            <div class="col-3 text-center">
              <button v-bind:class="button_agregar" v-on:click="Validar_Permiso('Guardar', 'add_contratos', 1)">Guardar</button>
              <button v-bind:class="button_modificar" v-on:click="Validar_Permiso('Guardar', 'mod_contratos', 1)">Guardar</button>
              <button v-bind:class="button_eliminar" v-on:click="Validar_Permiso('Guardar', 'del_contratos', 2)">Eliminar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import GeneralMixin from "@/components/mixins/General";

export default {
  mixins: [GeneralMixin],
  data() {
    return {
      unidades: [],
      name: "Agregar",
      loading: "",
      result: "d-none",
      form_contra: "col-md-8 col-12",
      button_eliminar: "btn btn-danger mt-2",
      button_agregar: "btn btn-success mt-2",
      button_modificar: "btn btn-success mt-2 d-none",
      contrato: {
        idcliente: 0,
        nomcli: "",
        fecha_ini: new Date().toISOString().substr(0, 10),
        fecha_fin: new Date().toISOString().substr(0, 10),
        cant_user_web: 0,
        cant_user_movil: 0,
        cant_sucursales: 0,
        iddocum_venta: 0,
        folio: "",
        status: 1,
      },
      modo: 1,
      modulos: [],
      clientes: [],
      clientes_autocomplete: [],
    };
  },
  methods: {
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    Listo() {
      this.loading = "d-none";
      this.result = "";
    },
    Guardar: function (status) {
      if (!this.Validar(status)) {
        return;
      }
      var that = this;
      this.Cargando();

      this.contrato.status = status;
      var modulos = new Array();
      for (var i = 0; i < this.modulos.length; i++) {
        if (this.modulos[i].check == true) {
          modulos.push(this.modulos[i]);
        }
      }

      this.contrato.modulos = modulos;

      if (this.modo == 1) {
        for (var j = 0; j < this.clientes_autocomplete.length; j++) {
          if (this.clientes_autocomplete[j].trim() == $("#nomcli").val().trim()) {
            this.contrato.idcliente = this.clientes[j].idcliente;
          }
        }
      }

      if (this.modo == 2) {
        var guardar = that.$http.put(
          "contratos/" + that.$route.params.idcontrato,
          {
            contrato: that.contrato,
          },
          {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          }
        );
      } else {
        var guardar = that.$http.post(
          "contratos",
          {
            contrato: that.contrato,
          },
          {
            headers: this.get_request_headers({
              accesstoken: localStorage.getItem("tokenmsal"),
            }),
          }
        );
      }

      guardar
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.resp == "Excelente") {
            if (this.modo == 1) {
              toastr.clear();
              toastr.success("Contrato Agregado");
            } else {
              if (status == 2) {
                toastr.clear();
                toastr.success("Contrato Eliminado");
              } else {
                toastr.clear();
                toastr.success("Contrato Actualizado");
              }
            }
            that.$router.push({ name: "Contratos" });
          } else {
            toastr.clear();
            toastr.error(respuestaJson.resp);
            that.Listo();
          }
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          toastr.clear();
          toastr.error("Problemas para guardar contrato");
          that.Listo();
        });
    },
    Validar: function (status) {
      var that = this;
      var pasar = true;
      toastr.clear();
      var fecha_actual = new Date().toISOString().substr(0, 10);
      var un_modulo = false;
      for (var i = 0; i < this.modulos.length; i++) {
        if (this.modulos[i].check == true) {
          un_modulo = true;
        }
      }
      if ($("#nomcli").val().trim().length == 0 && this.modo == 1 && status != 2) {
        toastr.error("Cliente Obligatorio");
        $("#nomcli").focus();
        pasar = false;
      } else if (this.contrato.fecha_ini < fecha_actual && this.modo == 1 && status != 2) {
        toastr.error("Fecha de Inicio Inválida");
        $("#fecha_ini").focus();
        pasar = false;
      } else if (this.contrato.fecha_fin <= fecha_actual && status != 2) {
        toastr.error("Fecha fin Inválida");
        $("#fecha_fin").focus();
        pasar = false;
      } else if (this.contrato.cant_user_web <= 0 && status != 2) {
        toastr.error("Cantidad de Usuarios Web obligatorio");
        $("#cant_user_web").focus();
        pasar = false;
      } else if (this.contrato.cant_user_movil <= 0 && status != 2) {
        toastr.error("Cantidad de Usuarios Movil obligatorio");
        $("#cant_user_movil").focus();
        pasar = false;
      } else if (this.contrato.cant_sucursales <= 0 && status != 2) {
        toastr.error("Cantidad de Sucursal Obligatorio");
        $("#cant_sucursales").focus();
        pasar = false;
      } else if (un_modulo == false && status != 2) {
        toastr.error("Debes seleccionar por lo menos un modulo");
        pasar = false;
      }

      return pasar;
    },
    Consultar_Clientes: function () {
      var that = this;
      this.$http
        .get("autocomplete/clientes", {
          headers: this.get_request_headers({
            accesstoken: localStorage.getItem("tokenmsal"),
          }),
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.clientes = respuestaJson.clientes;
          this.clientes_autocomplete = respuestaJson.autocomplete;
          if (this.clientes.length == 0) {
            toastr.error("Dar de alta clientes primero");
            this.$router.push({ name: "Contratos" });
          } else {
            if (this.modo == 1) {
              that.autocomplete(document.getElementById("nomcli"), that.clientes_autocomplete);
            }
            this.Consultar_Modulos();
          }
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          toastr.clear();
          toastr.error("Problemas para consultar clientes");
          this.$router.push({ name: "Contratos" });
        });
    },
    Consultar_Modulos: function () {
      var that = this;
      this.$http
        .get("modulos", {
          headers: this.get_request_headers({
            accesstoken: localStorage.getItem("tokenmsal"),
          }),
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.modulos = respuestaJson;
          if (this.modulos.length == 0) {
            toastr.error("Dar de alta modulos primero");
            this.$router.push({ name: "Contratos" });
          } else {
            if (this.modo == 2) {
              this.Consultar_Contrato();
            } else {
              this.Listo();
            }
          }
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          toastr.clear();
          toastr.error("Problemas para consultar modulos");
          this.$router.push({ name: "Contratos" });
        });
    },
    Colocar_Modulos(modulos_contrato) {
      for (var i = 0; i < this.modulos.length; i++) {
        for (var j = 0; j < modulos_contrato.length; j++) {
          if (this.modulos[i].idmodulo == modulos_contrato[j].idmodulo) {
            this.modulos[i].check = true;
          }
        }
      }
      this.Listo();
    },
    Consultar_Contrato() {
      var that = this;
      this.$http
        .get("contratos/" + this.$route.params.idcontrato, {
          headers: this.get_request_headers({
            accesstoken: localStorage.getItem("tokenmsal"),
          }),
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.length > 0) {
            this.contrato = respuestaJson[0];
            if (this.modo == 2) {
              $("#nomcli").attr("disabled", true);
              $("#fecha_ini").attr("disabled", true);
              $("#nomcli").val(this.contrato.nomcli.trim());
              this.Colocar_Modulos(this.contrato.modulos);
            } else {
              $("#nomcli").attr("disabled", false);
              $("#fecha_ini").attr("disabled", false);
              this.Listo();
            }
          } else {
            toastr.clear();
            toastr.error("No encontre el contrato");
            that.$router.push({ name: "Contratos" });
          }
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          toastr.clear();
          toastr.error("Problemas para consultar el contrato");
          that.$router.push({ name: "Contratos" });
        });
    },
    Validar_Permiso(funcion, permiso, param1, param2) {
      var that = this;

      this.$store
        .dispatch("Validar_Permiso", {
          name: permiso,
          permisos: this.usuario.acceso_evolution,
        })
        .then((data) => {
          if (data) {
            var ejecutar = "that." + funcion + "(" + param1 + "," + param2 + ")";
            eval(ejecutar);
          } else {
            toastr.clear();
            toastr.error("No tienes permiso para esta funcion");
          }
        })
        .catch((error) => {
          if (error.body.code == "MSAL_TOKEN_IS_NOT_VALID") {
            this.$msal.signOut();
          }
          toastr.clear();
          toastr.error("No tienes permiso para esta función");
        });
    },
    autocomplete(inp, arr) {
      /*the autocomplete function takes two arguments,
      the text field element and an array of possible autocompleted values:*/
      var currentFocus;
      /*execute a function when someone writes in the text field:*/
      inp.addEventListener("input", function (e) {
        var a,
          b,
          i,
          val = this.value;
        /*close any already open lists of autocompleted values*/
        closeAllLists();
        if (!val) {
          return false;
        }
        currentFocus = -1;
        /*create a DIV element that will contain the items (values):*/
        a = document.createElement("DIV");
        a.setAttribute("id", this.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        /*append the DIV element as a child of the autocomplete container:*/
        this.parentNode.appendChild(a);
        /*for each item in the array...*/
        for (i = 0; i < arr.length; i++) {
          /*check if the item starts with the same letters as the text field value:*/
          if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
            /*create a DIV element for each matching element:*/
            b = document.createElement("DIV");
            /*make the matching letters bold:*/
            b.innerHTML = "<small>" + arr[i].substr(0, val.length) + "</small>";
            b.innerHTML += arr[i].substr(val.length);
            /*insert a input field that will hold the current array item's value:*/
            b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
            /*execute a function when someone clicks on the item value (DIV element):*/
            b.addEventListener("click", function (e) {
              /*insert the value for the autocomplete text field:*/
              inp.value = this.getElementsByTagName("input")[0].value;
              /*close the list of autocompleted values,
                  (or any other open lists of autocompleted values:*/
              closeAllLists();
            });
            a.appendChild(b);
          }
        }
      });
      /*execute a function presses a key on the keyboard:*/
      inp.addEventListener("keydown", function (e) {
        var x = document.getElementById(this.id + "autocomplete-list");
        if (x) x = x.getElementsByTagName("div");
        if (e.keyCode == 40) {
          /*If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
          currentFocus++;
          /*and and make the current item more visible:*/
          addActive(x);
        } else if (e.keyCode == 38) {
          //up
          /*If the arrow UP key is pressed,
            decrease the currentFocus variable:*/
          currentFocus--;
          /*and and make the current item more visible:*/
          addActive(x);
        } else if (e.keyCode == 13) {
          /*If the ENTER key is pressed, prevent the form from being submitted,*/
          e.preventDefault();
          if (currentFocus > -1) {
            /*and simulate a click on the "active" item:*/
            if (x) x[currentFocus].click();
          }
        }
      });
      function addActive(x) {
        /*a function to classify an item as "active":*/
        if (!x) return false;
        /*start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0;
        if (currentFocus < 0) currentFocus = x.length - 1;
        /*add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active");
      }
      function removeActive(x) {
        /*a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
          x[i].classList.remove("autocomplete-active");
        }
      }
      function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
          if (elmnt != x[i] && elmnt != inp) {
            x[i].parentNode.removeChild(x[i]);
          }
        }
      }

      document.addEventListener("click", function (e) {
        closeAllLists(e.target);
      });
    },
  },
  computed: {
    usuario() {
      return this.$store.getters.getUsuario;
    },
  },
  created() {
    var that = this;
    if (this.$route.params.idcontrato != undefined) {
      this.name = "Editar";
      this.form_contra = "d-none";
      this.modo = 2;
      this.button_eliminar = "btn btn-danger mt-2";
      this.button_modificar = "btn btn-success mt-2";
      this.button_agregar = "btn btn-success mt-2 d-none";
    } else {
      this.button_eliminar = "d-none";
      this.button_modificar = "btn btn-success mt-2 d-none";
      this.button_agregar = "btn btn-success mt-2";
    }
    var name = "add_contratos";
    if (this.modo == 2) {
      name = "mod_contratos";
    }
    if (this.usuario.acceso_evolution != undefined) {
      this.$store
        .dispatch("Validar_Permiso", {
          name: name,
          permisos: this.usuario.acceso_evolution,
        })
        .then((data) => {
          if (data) {
            this.Consultar_Clientes();
          } else {
            toastr.clear();
            toastr.error("No tienes permiso para esta funcion");
            that.loading = "d-none";
          }
        });
    }
  },
  mounted() {},
};
</script>

<style>
.autocomplete {
  /*the container must be positioned relative:*/
  position: relative;
  display: inline-block;
}
.autocomplete-items {
  position: absolute;
  margin-left: 14px;
  margin-right: 14px;
  border: 1px solid #d4d4d4;
  border-bottom: 1px solid #d4d4d4;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
}
.autocomplete-items div {
  padding: 5px;
  cursor: pointer;
  background-color: #fff;
  *border-bottom: 1px solid #d4d4d4;
}
.autocomplete-items div:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}
.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}
</style>
